import { forwardRef } from "react";
import React, { useId } from "react";
function SvgAiLunaTagFull({ title, titleId, ...props }, ref) {
  const id = useId();
  const toAppend = "_" + id;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={62}
      height={20}
      fill="none"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <rect
        width={62}
        height={20}
        fill="url(#ai-luna-tag-full_svg__a)"
        rx={2}
      />
      <path
        fill="#fff"
        d="M4.972 14V5.492h1.656v6.924h3.792V14H4.972Zm10.778.192c-.456 0-.884-.068-1.284-.204a2.923 2.923 0 0 1-1.032-.612 3.062 3.062 0 0 1-.696-1.008c-.168-.4-.252-.86-.252-1.38V5.492h1.656v5.376c0 .56.144.984.432 1.272.288.288.68.432 1.176.432.504 0 .9-.144 1.188-.432.288-.288.432-.712.432-1.272V5.492h1.656v5.496c0 .52-.088.98-.264 1.38a2.841 2.841 0 0 1-1.728 1.62c-.4.136-.828.204-1.284.204ZM27.41 14l-3.864-6.036V14H21.89V5.492h2.064l3.54 5.628V5.492h1.656V14h-1.74Zm9.743-1.944h-3.456L32.99 14h-1.752l3.264-8.508h1.92L39.661 14h-1.8l-.708-1.944Zm-2.904-1.512h2.352l-1.176-3.216-1.176 3.216ZM53.429 10.857c.052 0 .098.035.112.086.442 1.598.774 1.931 2.373 2.373a.117.117 0 0 1 0 .225c-1.598.442-1.931.774-2.373 2.373a.117.117 0 0 1-.225 0c-.442-1.598-.774-1.931-2.373-2.373a.117.117 0 0 1 0-.225c1.599-.442 1.931-.774 2.373-2.373a.117.117 0 0 1 .113-.086ZM48.714 4c.097 0 .181.064.207.157.81 2.93 1.42 3.541 4.35 4.35a.215.215 0 0 1 0 .414c-2.93.81-3.54 1.42-4.35 4.35a.214.214 0 0 1-.413 0c-.81-2.93-1.42-3.54-4.351-4.35a.215.215 0 0 1 0-.413c2.93-.81 3.541-1.42 4.35-4.35A.215.215 0 0 1 48.715 4Z"
      />
      <defs>
        <linearGradient
          id={`ai-luna-tag-full_svg__a${toAppend}`}
          x1={62}
          x2={7.496}
          y1={13.542}
          y2={-14.546}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#691C9C" />
          <stop offset={0.65} stopColor="#1F3CD7" />
          <stop offset={1} stopColor="#1088EB" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgAiLunaTagFull);
export default ForwardRef;
